import React, { useState, useEffect, Fragment } from "react";
import Axios from "axios";
import { MainBlock, SelectForm } from "../../../components/common/Buttons";
import { Divs } from "../../../components/common/StyledComponents";
import { antdMessageSuccess, phonenumberValid, antdMessageError } from "../../../helpers/Utils";
import { Alert } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { AiOutlineClose } from "react-icons/ai";
import { useMutation, useQueryClient } from "react-query";
import { ButtonSecondary } from "../../../components/globals";
import { colors } from "../../../utils/colors";
import ListSmsSendings from "../../../components/table/ListSmsSendings";

export default function RenderSms({
  enableOnSendSmSClick = false,
  onSendSmSClick,
  checkedIds,
  onSmsSentProp,
  mode,
  disabled,
  id,
  phoneNumber,
  shipping_address_street,
  orderId,
  shipments,
  sms_sendings,
  fetchOrderById,
  updateOpennedModalTables = () => {},
  opennedModalTables = () => {},
  update_step,
  closePopover,
  chekedItemsId
}) {
  const [smsTemplates, setSmsTemplates] = useState([]);
  useEffect(() => {
    const fetchSmsTemplates = async () => {
      try {
        const { data } = await Axios.get("/pickups/requests/sms_templates");
        const templates = data.map((e) => ({
          label: e.message,
          value: e.body,
          identifier: e.identifier,
        }));
        setSmsTemplates(templates);
      } catch (err) {
        console.log("Error: ", err);
      }
    };

    fetchSmsTemplates();
  }, []);
  if (mode == "Simple") {
    return (
      <div style={{ width: 400 }}>
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="font-weight-bold">
            SMS siuntimas numeriui
            {
              <span
                className={phonenumberValid(phoneNumber) ? "" : "text-danger"}
              >
                {phoneNumber}
              </span>
            }
          </div>
          <AiOutlineClose
            className="pl-2 cursor-pointer"
            size={25}
            color={"#BFBFBF"}
            onClick={() => closePopover()}
          />
        </div>
        <SmsSending
          mode={mode}
          onSmsSent={() => {
            if (onSmsSentProp) {
              onSmsSentProp();
            }
          }}
          checkedIds={checkedIds}
          enableOnSendSmSClick={enableOnSendSmSClick}
          onSendSmSClick={() => {
            if (enableOnSendSmSClick) {
              onSendSmSClick();
            }
          }}
          id={id}
          chekedItemsId={chekedItemsId}
          sms_sendings={sms_sendings}
          fetchOrderById={fetchOrderById}
          smsItems={smsTemplates}
          phoneNumber={phoneNumber}
          shipping_address_street={shipping_address_street}
          orderId={orderId}
          shipments={shipments}
          update_step={update_step}
        />
      </div>
    );
  }
  return (
    <Divs>
      <MainBlock
        color={"#adcb35"}
        action={opennedModalTables.sms_sendings}
        onChange={() => updateOpennedModalTables("sms_sendings")}
      >
        SMS siuntimas numeriui
        {
          <span className={phonenumberValid(phoneNumber) ? "" : "text-danger"}>
            {phoneNumber}
          </span>
        }
      </MainBlock>
      {opennedModalTables.sms_sendings && (
        <div className="col-12 bg-silver">
          <SmsSending
            disabled={disabled}
            id={id}
            sms_sendings={sms_sendings}
            fetchOrderById={fetchOrderById}
            smsItems={smsTemplates}
            phoneNumber={phoneNumber}
            shipping_address_street={shipping_address_street}
            orderId={orderId}
            shipments={shipments}
          />
        </div>
      )}
    </Divs>
  );
}

function SmsSending({
  enableOnSendSmSClick,
  onSmsSent,
  onSendSmSClick = () => {},
  checkedIds,
  disabled,
  id,
  mode,
  phoneNumber,
  smsItems,
  shipping_address_street,
  orderId,
  shipments,
  sms_sendings,
  update_step,
  chekedItemsId
}) {
  useEffect(() => {
    if (mode == "Simple") {
      const smsIdentifier = chekedItemsId && chekedItemsId?.length > 0 ? 'sms_user' : 'pickup_sms';
      const find_with_pickup_sms = smsItems.find((e) => e.identifier === smsIdentifier);
      
      if (find_with_pickup_sms) {
        setSmsText(find_with_pickup_sms.value, find_with_pickup_sms);
      }
    }
  }, [smsItems]);
  const [bodyText, setBodyText] = useState("");
  const [bodyTextID, setBodyTextID] = useState(undefined);
  const [alertText, setAlertText] = useState({
    success: "success",
    text: "",
    show: false,
  });

  const mutationPUTProductStatus = useMutation({
    mutationFn: (products) =>
      Axios({
        url: `/pickups/requests/update_rows_status`,
        method: "PUT",
        params: {
          status: products.status,
          ids: products.ids,
        },
      }).then((res) => res.data),
    onSuccess: () => {
      sendSms();
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  const onSummonCustomerlHandler = () => {
      mutationPUTProductStatus.mutate({
        ids: checkedIds,
        status: 'client_called',
      });
  };

  const utils = useQueryClient();
  // mutation
  const mutationSms = useMutation({
    mutationFn: (variables) => {
      return Axios.post(`/pickups/requests/sms_sending_create`, variables).then(
        (res) => res.data
      );
    },
    onSuccess: async () => {
      await utils.invalidateQueries(["requests", { record_id: id }]);

      antdMessageSuccess();
      setBodyTextID("");
      setBodyText("");
      if (onSmsSent) {
        onSmsSent();
      }
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  const sendSms = () => {
    setAlertText({
      show: false,
    });
    // cia
    const variables = {
      pickup_request_id: id,
      sms_sending: {
        body: bodyText,
        number: phoneNumber,
      },
    };
    if (!bodyText || !phoneNumber) {
      return setAlertText({
        success: "error",
        text: "Užpildykite teksto laukelį.",
        show: true,
      });
    }
    if (enableOnSendSmSClick) {
      onSendSmSClick();
    }
    if (mode === "Simple" && !chekedItemsId) {
      return update_step({
        body: bodyText,
        number: phoneNumber,
      });
    }
    return mutationSms.mutate(variables);
  };

  const setSmsText = (evt, arg) => {
    let value = evt;
    if (value.search("[SHOP]") !== -1) {
      value = value.split("#[SHOP]").join(shipping_address_street);
    }
    if (value.search("[uzsakymo nr]") !== -1) {
      value = value.split("#[uzsakymo nr]").join(orderId || `T${id}`);
    }
    if (value.search("[ITEM]") !== -1) {
      let itemNames = [];
      if (chekedItemsId && chekedItemsId.length > 0) {
        chekedItemsId.forEach(itemId => {
          shipments?.forEach(shipment => {
            if (shipment?.id == itemId) {
              itemNames.push(shipment?.title);
            }
          });
        });
        value = value.split("#[ITEM]").join(itemNames.join(", "));
      }
    }
    if (value.search("[ORDER]") !== -1) {
      value = value.split("#[ORDER]").join(orderId || `T${id}`);
    }

    if (value.search("[tracking link]") !== -1) {
      let courier_trackings = [];
      let courier_trackings_number = [];
      shipments.forEach((ship) => {
        ship.courier_trackings?.forEach((track) => {
          courier_trackings.push(track.url);
          courier_trackings_number.push(track.number);
        });
      });
      if (courier_trackings.length === 1) {
        value = value.split("#[tracking link]").join(courier_trackings[0]);
        if (value.search("[tracking number]")) {
          value = value
            .split("#[tracking number]")
            .join(courier_trackings_number[0]);
        }
      } else if (courier_trackings.length > 1) {
        value = value
          .split("#[tracking link]")
          .join(courier_trackings.join(", "));
        if (value.search("[tracking number]")) {
          value = value
            .split("#[tracking number]")
            .join(courier_trackings_number.join(", "));
        }
      }
    }
    setBodyTextID(arg.value);
    setBodyText(value);
  };

  return (
    <Fragment>
      {!disabled && (
        <>
          {alertText.show && (
            <Alert
              className="mt-2"
              message={alertText.text}
              type={alertText.success}
              showIcon
            />
          )}
          <div className="pt-2 mb-2">
            <SelectForm
              onlyPlaceholder="Šablonai"
              options={smsItems}
              onChange={(evt, arg) => setSmsText(evt, arg)}
              value={bodyTextID}
            />
          </div>
          <div>
            <div style={{ width: "100%" }}>
              <TextArea
                placeholder="Tekstas"
                value={bodyText}
                autoSize={{ minRows: 2, maxRows: 6 }}
                onChange={(e) => setBodyText(e.target.value)}
              />
            </div>
            <div
              style={{
                width: "100%",
                marginTop: "8px",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              {phonenumberValid(phoneNumber) && (
                <ButtonSecondary
                  style={{
                    width: 70,
                  }}
                  bgColor={colors["orange"]}
                  bgActiveColor={colors["orange"]}
                  loading={enableOnSendSmSClick ? mutationPUTProductStatus.isLoading : mutationSms.isLoading}
                  onClick={enableOnSendSmSClick ? onSummonCustomerlHandler : sendSms}
                  >
                  Siųsti
                </ButtonSecondary>
              )}
            </div>
          </div>
        </>
      )}
      {mode !== "Simple" && (
        <table className="table table-hover pt-3">
          <ListSmsSendings sms_sendings={sms_sendings} />
        </table>
      )}
    </Fragment>
  );
}
